import domain from "./domain";
import { CollectionResource } from "dy-frontend-http-repository/lib/data/resources";
import { WorkspaceResource } from "dy-frontend-http-repository/lib/modules/Workspace/resources";
import { resetWorkspaces } from "./events";

export const $workspaces = domain
    .createStore<CollectionResource<WorkspaceResource, {}> | null>(null)
    .reset(resetWorkspaces);
